import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import { green700, grey200, red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import Autorenew from 'material-ui/svg-icons/action/autorenew';
import { Link } from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
import config from 'cfg';

import styled from 'styled-components';

import SMPostDialog from '../SMPostDialog';

import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconShare from 'material-ui/svg-icons/social/share';

class F1HomeSMBrowser extends React.Component {
    static defaultProps = {
        eventId: 46
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            templates: [],
            gpxs: [],
            gpxsOld: []
        };
    }

    componentDidMount() {
        this.loadData();
    }

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    loadData = additionalStateParams => {
        let { eventId } = this.props;
        var user = this.context.user;
        if (!user || !user.client) return null;
        return RCore.promiseProps({
            gpxs: fetch(`${config.apis.ss2}/f1/gpx`).then(response => response.json()),
            gpxsOld: fetch(`${config.apis.ss2}/f1/gpx?year=2017`).then(response => response.json())
        })
            .then(result => {
                // console.log("!!", res)
                this.setState({
                    ...result,
                    isLoading: false,
                    ...additionalStateParams
                });
            })
            .catch(e => {
                this.setState({
                    error: e,
                    isLoading: false,
                    ...additionalStateParams
                });
            });
    };

    render() {
        const user = this.context.user;
        let { gpxs, gpxsOld } = this.state;
        return (
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <h1>2018 season</h1>
                        <ul>
                            {gpxs.map(g => (
                                <li key={g.id}>
                                    <Link to={`/sm/browser/f1/gpx/${g.id}`}>{g.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-md-6">
                        <h1>2017 season</h1>
                        <ul>
                            {gpxsOld.map(g => (
                                <li key={g.id}>
                                    <Link to={`/sm/browser/f1/gpx/${g.id}`}>{g.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default F1HomeSMBrowser;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/F1HomeSMBrowser.js
 **/